import { useRef } from "react";

import ua_flag from "../../../assets/images/icons/ua_flag.svg";

export const Phone = ({onInputChange, onInputBlur, onError}) => {
    
    const phone  = useRef(null);

    const handleInputChange = () => {
        const name = phone.current.name
        const value = phone.current.value
        onInputChange({name: name, value: value});
    }

    const handleInputBlur = () => {
        const name = phone.current.name
        const value = phone.current.value
        onInputBlur({name: name, value: value});
    }

    return (
        <div className="mb-3">
            <label  className="form-label fs-6 fw-bold">Номер телефону</label>
            <div className="input-group">
                <span className="input-group-text border-dark" id="inputGroup-sizing-default">
                    <img className="me-2" src={ua_flag} alt="Прапор України" />
                    +380
                </span>
                <input type="text" className="form-control  border-dark" name="phone" pattern="\d*" maxLength="9" placeholder="Введіть нормер телефону"
                    ref={phone}
                    onChange={() => handleInputChange()}
                    onBlur={() => handleInputBlur()}
                />
            </div>
            {onError['phone'] && <div className="error-message">{onError['phone']}</div>} 
        </div>
    )
}
// 
